import { post,put,get } from './axios'

//안씀
export const getGiasDomain = async (params) => {
    const { status, data } = await get("/gias/selectGiasDomainAjax", params)

    if (status === 200 || status === 201) {
        return data
    }
}


export const getGiasPrinciple = async (params) => {
    const { status, data } = await get("/gias/selectGiasPrincipleAjax", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const getGiasStandard = async (params) => {
    const { status, data } = await get("/gias/selectGiasStandardAjax", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const getIQCApproveList = async (params) => {
    const { status, data } = await get("/gias/IQCApproveList", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const getGiasEvaluation = async (params) => {
    const { status, data } = await get("/gias/selectGiasEvaluationAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const insertGias = async (params) => {
    const { status, data } = await post("/gias/insertGias", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const updateGias = async (params) => {
    const { status, data } = await post("/gias/updateGias", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const updateGiasByEQC = async (params) => {
    const { status, data } = await post("/gias/updateGiasByEQC", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const updateGiasFile = async (params) => {
    const { status, data } = await post("/gias/updateGiasFile", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const finalizeEvaluation = async (params) => {
    const { status, data } = await post("/gias/finalizeEvaluation", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const sendIQCMail = async (params) => {
    const { status, data } = await post("/gias/sendIQCMail", params);
  
    if (status === 200 || status === 201) {
      return data; 
    }
};

export const updateFeedbackForIQA = async (params) => {
    const { status, data } = await post("/gias/updateFeedbackForIQA", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const insertEqcComment = async (params) => {
    const { status, data } = await post("/gias/insertEqcComment", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};


export const updateEvaluationRequestForIQC = async (params) => {
    const { status, data } = await post("/gias/updateEvaluationRequestForIQC", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const updateFeedbackCompletionStatus = async (params) => {
    const { status, data } = await post("/gias/updateFeedbackCompletionStatus", params,true);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const getGiasEvlList = async (params) => {
    const { status, data } = await get("/gias/evlOrgList", params);

    if (status === 200 || status === 201) {
        return data;
    }
};


export const selectPreviousYear = async (params) => {
    const { status, data } = await get("/gias/selectPreviousYear", params);

    if (status === 200 || status === 201) {
        return data;
    }
};


export const getGias3YearAvg = async (params) => {
    const { status, data } = await get("/gias/gias3YearAvg", params);

    if (status === 200 || status === 201) {
        return data;
    }
};


export const getAdminGiasEvlList = async (params) => {
    const { status, data } = await get("/gias/adminEvlOrgList", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const selectGiasWeight = async (params) => {
    const { status, data } = await get("/gias/selectGiasWeight", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const selectAnotherOrgWeight = async (params) => {
    const { status, data } = await get("/gias/selectAnotherOrgWeight", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const getMemberApprove = async (params) => {
    const { status, data } = await get("/gias/memberApprove", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const getGiasAllEvaluation = async (params) => {
    const { status, data } = await get("/gias/giasAllEvaluation", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const getGiasAllData = async (params) => {
    const { status, data } = await get("/gias/giasAllData", params)

    if (status === 200 || status === 201) {
        return data
    }
}

export const getGiasAvg = async (params) => {
    const { status, data } = await get("/gias/giasAvg", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const getGiasAllAvg = async (params) => {
    const { status, data } = await get("/gias/giasAllAvg", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const getAllOrgStats = async (params) => {
    const { status, data } = await get("/gias/allOrgStats", params);

    if (status === 200 || status === 201) {
        return data;
    }
};

export const insertIQCGias = async (params) => {
    const { status, data } = await post("/gias/insertIQCGias", params);
    if (status === 200 || status === 201) {
      return data;
    }
};
  
export const checkSavedGIAS = async (params) => {
    const { status, data } = await get("/gias/checkSavedGIAS", params);

    if (status === 200 || status === 201) {
        return data;
    }
};


export const selectCertGias = async (params) => {
    const { status, data } = await get("/gias/selectCertGias", params);

    if (status === 200 || status === 201) {
        return data;
    }
};